// WHAT A VUETIFY SLIDER HAS TO BE HANDED SO THAT IT DOES NOT ANSWER BACK.
//
// VSlider watches its `value` prop, assigns it to internalValue, and that setter CLAMPS the number
// to [min, max], ROUNDS it onto the step grid, and — if what comes out differs from what it was
// holding — emits `input`. So a slider SHOWN a value it does not like re-emits it as though the
// thumb had been moved, and neither the component listening nor its parent can tell that apart from
// a gesture. (vuetify 2.6.15, components/VSlider/VSlider.js: the internalValue setter and
// roundValue.)
//
// Wherever the slider is the only thing that ever moves the value, this is invisible: what arrives
// is what the slider itself last emitted, and it is already on its own grid. It stops being
// invisible the moment something ELSE moves the same number — the composer's zone bar moves a
// curve's k and n together, to wherever a boundary was dragged, and the levers beside it show that
// live. Every frame of that gesture then came back through the levers as an edit nobody made,
// snapped to the exponent lever's step of 0.05, and the shape walked a little further on each one:
// the boundary the editor had been told to hold still drifted three percent across one drag.
//
// So the value is put on the slider's own grid BEFORE it is handed over, by exactly the arithmetic
// VSlider would have used, and its setter then finds nothing to change and says nothing. Nothing is
// lost by rounding it here: the true number belongs in the field beside the slider, which has no
// grid, and the thumb was never able to stand anywhere but on one of these positions anyway.
export function sliderValue (value, range) {
  const at = Number(value)
  const bounds = range || {}
  const min = Number(bounds.min)
  const max = Number(bounds.max)
  if (!isFinite(at)) return at
  let held = at
  if (isFinite(min) && held < min) held = min
  if (isFinite(max) && held > max) held = max
  const step = Number(bounds.step) > 0 ? Number(bounds.step) : 0
  if (!step) return held
  // The step's own decimals, and the grid offset from the minimum, which is where VSlider anchors
  // it: a range starting at 1.05 with a step of 0.05 has positions at 1.05, 1.10, 1.15 and not at
  // 1.00, 1.05, 1.10.
  const text = String(bounds.step).trim()
  const dot = text.indexOf('.')
  const decimals = dot > -1 ? text.length - dot - 1 : 0
  const offset = min % step
  const snapped = Math.round((held - offset) / step) * step + offset
  return parseFloat(Math.min(snapped, max).toFixed(decimals))
}
